import payRequest from './payRequestService'
import returnPay from './returnPay'

export const payRequestService = payRequest;
export const returnPayService = returnPay;